export default "__VITE_ASSET__144b0f95__"